//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import access from "config/access";

// custom pages
import { mpcDetailStyles } from "./styles";
import tierRange from "apis/tierRange/tierratio";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
// material-ui icons
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function ViewShipTo(props) {
  const { state, dispatch } = useContext(Context);
  const { getTierrangeDetail, update } = tierRange();
  const history = useHistory();
  const location = useLocation();
  const classes = mpcDetailStyles();
  const [mpc, setMpc] = useState({});
  const [data, setData] = useState({});
  const [dataClone, setDataClone] = useState({});
  const [updated, setUpdated] = useState({});
  const [edit, setEdit] = useState(false);



  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Tier Range Detail"],
    });
  }, []);

  // handling api calls
  useEffect(() => {
   

    if (location?.state?.mpcId) {
      handleGet();
      return;
    }
    history.goBack();
  }, []);
 

  // authorized members api func
  const handleGet = async () => {
    try {
      let id = location?.state?.mpcId;
      let res = await getTierrangeDetail(id);
      if (res) {
        setData(res?.data);
        setDataClone(res?.data);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const handleUpdate = async () => {
    try {
      let arg = {};
      arg = { updated, id: data?.id };
      let res = await update(arg);
      if (res) {
        setDataClone({ ...dataClone, ...res?.data });
        setEdit(false);
        history.push("/dashboard/upload-success", {
          type: "Tier Range Data updated to our system successfully.",
        });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  let editObj = {
    tier_ratio: { edit: edit, type: "number" },
    tier_start_value: { edit: edit, type: "number" },
    tier_end_value: { edit: edit, type: "number" }
  };

  let nameObj = {
    id: "id",
    tier: "tier",
    tier_start_value: "tier_start_value",
    tier_end_value: "tier_end_value",
    tier_ratio: "Tier Ratio",
    loyalty_organization_name: "loyalty_organization_name",
    loyalty_site_id: "loyalty_site_id",
    // loyalty_category_code:"loyalty_category_code"
    label_class_code: "label_class_code"
  };
  const invalidChar = ['~', '`', '!', '#', '$', '%', '^', '*', '(', ')', '_', '+', '=', '', ';', ':', '<', '.', '>', '?', '|', '[', ']', '{', '}', '"', "'",'e','E']
  const blockInvalidChar = e => invalidChar.includes(e.key) && e.preventDefault();

  let offset = location?.state?.offset;

  return (
    <React.Fragment>
      <Grid container style={{ padding: 10 }}>
        <Grid item xs={6}>
          <Button
            className={classes.editBtn}
            onClick={() => {
              history.push("/dashboard/tierrange", { offset });
            }}
          >
            Back
          </Button>
        </Grid>
      </Grid>
      {/* <Grid container>
        {Object.keys(data)?.map((d, i) => (
          <Grid
            xs={6}
            style={{ padding: 10, fontSize: 18, alignSelf: "center" }}
          >
            {editObj[d]?.edit ? (
              editObj[d]?.type === "select" ? (
                <Grid container>
                  <Grid item xs={12}>
                    <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                      {nameObj[d]}&nbsp;:&nbsp;
                    </span>
                    <CssTextField
                      variant="outlined"
                      select
                      fullWidth
                      style={{ width: 200 }}
                      value={data?.[d]}
                      onChange={(e) => {
                        console.log({ d: data?.[d] });
                        console.log({ e: e.target.value });
                        setData({ ...data, [d]: e.target.value });
                        setUpdated({ ...updated, [d]: e.target.value });
                      }}
                    >
                      {editObj[d]?.options.map((r, i) => (
                        <MenuItem value={r.value} key={i}>
                          {r.label}
                        </MenuItem>
                      ))}
                    </CssTextField>
                  </Grid>
                </Grid>
              ) : (
                <Grid container>
                  <Grid item xs={12}>
                    <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                      {nameObj[d]}&nbsp;:&nbsp;
                    </span>
                    <CssTextField
                      fullWidth
                      variant="outlined"
                      type={editObj[d]?.type}
                      style={{ width: 200 }}
                      disabled={!edit}
                      value={data?.[d]}
                      onChange={(e) => {
                        if (editObj[d]?.type === "text") {
                          setData({ ...data, [d]: e.target.value });
                          setUpdated({ ...updated, [d]: e.target.value });
                        }
                        if (editObj[d]?.type === "number") {
                          setData({ ...data, [d]: parseInt(e.target.value) });
                          setUpdated({
                            ...updated,
                            [d]: parseInt(e.target.value),
                          });
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              )
            ) : (
              <div>
                <span style={{ fontWeight: "bold" }}>{nameObj[d]}</span> :{" "}
                {typeof data?.[d] == "boolean" ? (
                  data?.[d] ? (
                    <span
                      style={{
                        backgroundColor: "green",
                        borderRadius: 10,
                        color: "#fff",
                        padding: 5,
                        fontWeight: "bold",
                        letterSpacing: 1,
                        textAlign: "center",
                      }}
                    >
                      Active
                    </span>
                  ) : (
                    <span
                      style={{
                        backgroundColor: "red",
                        borderRadius: 10,
                        color: "#fff",
                        padding: 5,
                        fontWeight: "bold",
                        letterSpacing: 1,
                        textAlign: "center",
                      }}
                    >
                      Inactive
                    </span>
                  )
                ) : (
                  data?.[d]
                )}
              </div>
            )}
          </Grid>
        ))}
      </Grid> */}
      <Grid container>
        <div className={classes.firstDiv}>
          <div className={classes.secondDiv}>Tier Range Details</div>
        </div>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>ID</span> :{" "}
            {data.id}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Tier</span> :{" "}
            {data.tier}
          </div>
        </Grid>
        {/* <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Tier Start Value</span> :{" "}
            {data.tier_start_value}
          </div>
        </Grid> */}
        <Grid xs={12} lg={6} className={classes.grid}>
          {(editObj["tier_start_value"]?.edit && state?.userInfo?.role_id == 10)? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["tier_start_value"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  fullWidth
                  variant="outlined"
                  type={editObj["tier_start_value"]?.type}
                  className={classes.cssTextField}
                  disabled={!edit}
                  onKeyDown={blockInvalidChar}
                  value={data?.["tier_start_value"]}
                  onChange={(e) => {
                    if (editObj["tier_start_value"]?.type === "text") {
                      setData({
                        ...data,
                        ["tier_start_value"]: e.target.value,
                      });
                      setUpdated({
                        ...updated,
                        ["tier_start_value"]: e.target.value,
                      });
                    }
                    if (editObj["tier_start_value"]?.type === "number") {
                      setData({
                        ...data,
                        ["tier_start_value"]: e.target.value,
                      });
                      setUpdated({
                        ...updated,
                        ["tier_start_value"]:e.target.value,
                      });
                    }
                  }}
                />
              </Grid>
            </Grid>
          ) : (
            <div>
              <span className={classes.gridSpan}>Tier Start Value</span> :{" "}
              {data.tier_start_value}
            </div>
          )}
        </Grid>
        {/* <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>
              Tier End Value
            </span>{" "}
            : {data.tier_end_value}
          </div>
        </Grid> */}
        <Grid xs={12} lg={6} className={classes.grid}>
          {(editObj["tier_end_value"]?.edit && state?.userInfo?.role_id == 10)? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["tier_end_value"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  fullWidth
                  variant="outlined"
                  type={editObj["tier_end_value"]?.type}
                  className={classes.cssTextField}
                  disabled={!edit}
                  value={data?.["tier_end_value"]}
                  onChange={(e) => {
                    if (editObj["tier_end_value"]?.type === "text") {
                      setData({
                        ...data,
                        ["tier_end_value"]: e.target.value,
                      });
                      setUpdated({
                        ...updated,
                        ["tier_end_value"]: e.target.value,
                      });
                    }
                    if (editObj["tier_end_value"]?.type === "number") {
                      setData({
                        ...data,
                        ["tier_end_value"]: parseFloat(e.target.value),
                      });
                      setUpdated({
                        ...updated,
                        ["tier_end_value"]: parseFloat(e.target.value),
                      });
                    }
                  }}
                />
              </Grid>
            </Grid>
          ) : (
            <div>
              <span className={classes.gridSpan}>Tier End Value</span> :{" "}
              {data.tier_end_value}
            </div>
          )}
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          {editObj["tier_ratio"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["tier_ratio"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  fullWidth
                  variant="outlined"
                  type={editObj["tier_ratio"]?.type}
                  className={classes.cssTextField}
                  disabled={!edit}
                  value={data?.["tier_ratio"]}
                  onChange={(e) => {
                    if (editObj["tier_ratio"]?.type === "text") {
                      setData({
                        ...data,
                        ["tier_ratio"]: e.target.value,
                      });
                      setUpdated({
                        ...updated,
                        ["tier_ratio"]: e.target.value,
                      });
                    }
                    if (editObj["tier_ratio"]?.type === "number") {
                      setData({
                        ...data,
                        ["tier_ratio"]: parseFloat(e.target.value),
                      });
                      setUpdated({
                        ...updated,
                        ["tier_ratio"]: parseFloat(e.target.value),
                      });
                    }
                  }}
                />
              </Grid>
            </Grid>
          ) : (
            <div>
              <span className={classes.gridSpan}>Tier Ratio </span> :{" "}
              {data.tier_ratio}
            </div>
          )}
        </Grid>
        {/* <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Loyalty Category Code</span> :{" "}
            {data.loyalty_category_code}
          </div>
        </Grid> */}
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Loyalty Category Code</span> :{" "}
            {data.loyalty_category_code}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Label Class Code</span> :{" "}
            {data.label_class_code}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Label Class Code Description</span> :{" "}
            {data.label_class_code_description}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Org Name</span> :{" "}
            {data.loyalty_organization_name}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Site Name</span> :{" "}
            {data.loyalty_site_id}
          </div>
        </Grid>
        <Grid item xs={12} lg={2} className={classes.gridBtn}>
          <Grid item xs={12} lg={6}>
            {edit && (
              <Button
                className={classes.editCancelBtn}
                onClick={() => {
                  setData(dataClone);
                  setEdit(false);
                }}
              >
                Cancel
              </Button>
            )}
          </Grid>
          <Grid item xs={12} lg={6} >
            <Button
              className={classes.editBtn}
              onClick={() => {
                if (state?.userInfo?.editAction) {
                  if (edit) {
                    if (Object.keys(updated).length > 0) {
                      handleUpdate();
                      return;
                    }
                    toast.error("Edit atleast one field.", {
                      toastId: "update-btn",
                    });
                  }
                  else {
                    setEdit(true);
                  }
                  return;
                }
                else {
                  toast.error(state.userInfo?.editAccess)
                  return;
                }
              }}
            // disabled={!access['editAccess'][state.userInfo?.role]['mpcdetail']}
            >
              {edit ? "Update" : "Edit"}
            </Button>
          </Grid>
        </Grid>

      </Grid>
    </React.Fragment>
  );
}
